// Workspace Imports
import { graphics } from "GenAlphaModel";
// Local Imports
import type { DrawTo } from "../../../draw";
import * as style from "../../../style";
import { StyleTables } from "../../shared/styles";
import { Entity } from "../../../tree";

const table = StyleTables.instanceSelectionBox;

export class SelectionBox extends Entity<graphics.Bbox> {
  override readonly cache = this.makeCache<style.ShapeStyle>(table);
  override redraw = (to: DrawTo): unknown => {
    return to.bbox(this.data, this.cache.style);
  };
}
